/**
 * Created by Bowen on 10/16/2020.
 * Description:
 * Duplicated contact dialog
 * request:
 * 1. when input the email control, need to validate if the email is a duplicate email
 *    validate rules:
 *    (1) users input one email -> detect -> is a duplicated contact -> show the duplicated message -> input another email in
 *        other controls -> stop validate (high priority)
 *    (2) users input one email -> detect -> is a duplicated contact -> show the duplicated message -> modify the duplicated
 *        email -> need to validate again (high priority)
 *    (3) users input one email -> detect -> not a duplicated contact -> input another email in other email control -> detect
 *        -> the second email is a duplicated contact -> show the duplicated message -> modify the second duplicated email ->
 *        need to validate the second email again (not a high priority)
 * ------ maintenance history ------
 */

import { Component, ElementRef, OnDestroy, OnInit, Renderer2, AfterViewChecked } from '@angular/core';
import { of, Subscription } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { DuplicatedContactDialogService } from './duplicated-contact-dialog.service';
import { DialogAction } from './../../widgets/tam-dialog/tam-dialog.model';

@Component({
    selector: 'tam-duplicated-contact-dialog',
    templateUrl: './duplicated-contact-dialog.component.html',
    styleUrls: ['./duplicated-contact-dialog.component.scss'],
    standalone: false
})
export class DuplicatedContactDialogComponent implements OnInit, OnDestroy, AfterViewChecked {
    opened: boolean;
    config: any;

    private _destroySubscriptions: Array<Subscription> = [];
    private _element: HTMLElement;

    constructor(
        private _duplicatedContactDialogService: DuplicatedContactDialogService,
        private _renderer: Renderer2,
        private _elementRef: ElementRef,
    ) {
        this._element = this._elementRef.nativeElement;
    }

    ngOnInit() {
        this._destroySubscriptions.push(
            this._duplicatedContactDialogService.dialogOpen$
                .pipe(
                    catchError((err) => {
                        return of(null);
                    }),
                )
                .subscribe(action => {
                    if (action.type === DialogAction.OpenDialog) {
                        this.opened = true;
                        this.config = action.payload;
                    } else if (action.type === DialogAction.CloseDialog) {
                        this.clickClose();
                    }
                }),
        );
    }

    ngAfterViewChecked() {
        const isIEOrEdgeOrFirefox = /msie\s|trident\/|firefox\/|edge\//i.test(window.navigator.userAgent);
        const isSafari = (/safari/i.test(window.navigator.userAgent)) && !(/chrome/i.test(window.navigator.userAgent));
        // here is need to use render, because this class is not show in this dialog, this class only show in the tam-dialog
        if (isIEOrEdgeOrFirefox && this._element) {
            if (this._element.querySelector('.template-dialog-body')) {
                this._renderer.setStyle(this._element.querySelector('.template-dialog-body'), 'max-width', '756px');
            }
        } else if (isSafari && this._element) {
            if (this._element.querySelector('.template-dialog-body')) {
                this._renderer.setStyle(this._element.querySelector('.template-dialog-body'), 'max-width', '748px');
            }
        }
    }

    ngOnDestroy() {
        this._destroySubscriptions.forEach(item => item.unsubscribe());
    }

    clickClose() {
        this.opened = false;
        this.config = null;
    }

    trackByFn(index) {
        return index;
    }
}
